import React, { useState } from "react";
import { AiOutlineShareAlt } from "react-icons/ai";
import { IoChevronDown } from "react-icons/io5";
import { sharedWithName } from "../utilities/functions";
import { useNavigate } from "react-router-dom";

export default function SharesSection({
    title = "Shares",
    showHeader = true, // now controls summary visibility
    sharesCount = 0,
    sharedWith = [],
    spDetails = {},
    benDetails = {},
    type = "",
    q = "",
    onShareClick,
    maxHeight = 260,
}) {
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();
    const primaryShareName =
        sharedWith.length > 0
            ? sharedWithName(sharedWith[0], spDetails, benDetails)
            : null;

    const viewShare = (sw, name) => {
        navigate(`/sharing?type=${type}&q=${q}&sharedWith=${name.props.children}` );
    }

    return (
        <div className=" text-sm text-gray-100">
            {/* SUMMARY ROW (always visible when showHeader = true) */}
            {showHeader && (
                <div
                    className="flex gap-3 items-center py-3 cursor-pointer"
                    onClick={() => setExpanded(prev => !prev)}
                >
                    <span className=" truncate">
                        {sharesCount > 0 ? (
                            <>
                                Shared with{" "}
                                <span className="font-medium text-purple-400">
                                    {primaryShareName}
                                </span>
                                {sharesCount > 1 && (
                                    <span className="">
                                        {" "}+{sharesCount - 1} users
                                    </span>
                                )}
                            </>
                        ) : (
                            <span className="italic ">No shares yet</span>
                        )}
                    </span>

                    <IoChevronDown
                        className={`w-4 h-4 transition-transform ${expanded ? "rotate-180" : ""
                            }`}
                    />
                </div>

            )}

            {/* EXPANDED DETAILS */}
            {expanded && (
                <div className="border-t border-gray-600  py-3">
                    <div className="flex mb-2">
                        <button
                            onClick={onShareClick}
                            className="button-style flex items-center gap-2"
                        >
                            <AiOutlineShareAlt />
                            Share
                        </button>
                    </div>

                    {sharedWith.length === 0 ? (
                        <div className="italic py-4">
                            No shares yet.
                        </div>
                    ) : (
                        <ul
                            className="divide-y divide-gray-600 pr-2"
                            style={{ maxHeight, overflowY: "auto" }}
                        >
                            {sharedWith.map((sw) => {
                                const name = sharedWithName(sw, spDetails, benDetails)
                               return <li key={sw.id} className="cursor-pointer py-3" onClick={() => viewShare(sw, name)}>
                                    <div className="font-medium">
                                        {name}
                                    </div>
                                    <div className="text-xs truncate">
                                        {sw.id}
                                    </div>
                                </li>
                            })}
                        </ul>
                    )}
                </div>
            )}

        </div>
    );
}
